'use client';

import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
} from '@mui/material';
import { Email } from '@mui/icons-material';

export default function HeaderSection() {
  return (
    <Box sx={{ mb: 10 }}>
      <Grid container spacing={6} alignItems="center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 800,
              mb: 4,
              background: 'linear-gradient(45deg, #1e40af 30%, #3b82f6 90%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Conoce al Equipo
          </Typography>

          <Typography
            variant="h6"
            sx={{
              lineHeight: 1.7,
              mb: 4,
              color: 'text.secondary',
              fontSize: '1.1rem',
            }}
          >
            VIXIA SYSTEM nace de grupos de investigación de la Universidad de Vigo,
            especializándonos en soluciones tecnológicas para el análisis ambiental.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.8,
              mb: 4,
              color: 'text.primary',
              fontSize: '1rem',
            }}
          >
            Desarrollamos sistemas de muestreo automatizados y software personalizado
            para la gestión de datos medioambientales. Utilizamos sensores aéreos,
            inteligencia artificial, modelos predictivos y sistemas de información
            geográfica para ofrecer soluciones innovadoras.
          </Typography>

          {/* Llamada a la acción */}
          <Paper
            elevation={0}
            sx={{
              p: 4,
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              borderRadius: 3,
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: -50,
                right: -50,
                width: 200,
                height: 200,
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
              },
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, position: 'relative', zIndex: 1 }}>
              ¿Tienes un proyecto en mente?
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, opacity: 0.9, position: 'relative', zIndex: 1 }}>
              Contáctanos y hablemos sobre cómo podemos ayudarte
            </Typography>
            <Button
              variant="contained"
              startIcon={<Email />}
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#f8fafc',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                },
                transition: 'all 0.3s ease',
                position: 'relative',
                zIndex: 1,
              }}
              onClick={() => {
                document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Contactar Ahora
            </Button>
          </Paper>
        </Grid>

        {/* Imagen */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: -20,
                right: -20,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(45deg, #3b82f6 0%, #1e40af 100%)',
                borderRadius: 4,
                zIndex: 0,
                opacity: 0.1,
              },
            }}
          >
            <Box
              component="img"
              src="/img/miembros/vixia-members.webp"
              alt="Equipo Vixia System"
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 3,
                boxShadow: '0 20px 60px rgba(30, 64, 175, 0.2)',
                position: 'relative',
                zIndex: 1,
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}